import React, { useEffect } from 'react'
import { Modal, Form, Input, message } from 'antd'
import { inject, observer } from 'mobx-react'

const InternalMessageEditTitleModal = props => {
  const {
    isVisible,
    handleCancel,
    internalMessageStore,
    loadingAnimationStore,
    code,
    initialTitle,
  } = props

  const [form] = Form.useForm()

  useEffect(() => {
    if (isVisible) {
      form.setFieldsValue({ title: initialTitle })
    }
  }, [isVisible, initialTitle, form])

  const onFinish = async values => {
    try {
      loadingAnimationStore.showSpinner(true)
      await internalMessageStore.updateTitle(code, values.title)
      message.success('Cập nhật tiêu đề thành công!')
      handleCancel()
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <Modal
      title="Chỉnh sửa tiêu đề"
      visible={isVisible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      okText="Lưu"
      cancelText="Hủy"
      maskClosable={false}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="title"
          label="Tiêu đề"
          rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}
        >
          <Input placeholder="Nhập tiêu đề..." maxLength={255} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default inject(
  'internalMessageStore',
  'loadingAnimationStore'
)(observer(InternalMessageEditTitleModal))
